import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatTableDataSource} from '@angular/material/table';
import { MatCheckboxChange} from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {AuthService} from '../../../services/auth.service';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Ordered} from 'src/app/models/ordered';
import {OrderedService} from 'src/app/services/ordered.service';
import {MemberService} from 'src/app/services/member.service';
import {OrderedViewerDialogComponent} from '../ordered-viewer-dialog/ordered-viewer-dialog.component';
import {SubcategoryService} from 'src/app/services/subcategory.service';
import {ProductService} from 'src/app/services/product.service';
import {EventService} from 'src/app/services/event.service';
import {SlotService} from 'src/app/services/slot.service';
import {TopicService} from 'src/app/services/topic.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-ordered-dialog',
  templateUrl: './ordered-dialog.component.html',
  styleUrls: [ './ordered-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class OrderedDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public local_title: string;
  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;

  public allSubCategories: any[] = [];
  // public dataSource: MatTableDataSource<any>
  //  public displayedColumns: string[] = ['name', 'category', 'phone', 'select'];

  public topicDataSource: MatTableDataSource<any>
  public displayedTopicColumns: string[] = [ 'date', 'name', 'selected' ];

  public origins: any[] = []
  public origin: any = "";

  public paymentTypes: any[] = [];

  public selectedPaymentType: string = "";
  public currentTax: number = 0;
  public debit_ok: boolean = false;


  /////////////////////
  public tax_visible: boolean = false;
  public value_visible: boolean = false;
  public total_visible: boolean = false;
  public total_mt_visible: boolean = false;
  public tid_visible: boolean = false;
  public discount_visible: boolean = false;
  //////////////////////

  public members: any[] = []
  public searchMemberControl: FormControl;

  public controlByTopic: boolean = false;

  constructor (
    private _slotService: SlotService,
    private _eventService: EventService,
    private _topicService: TopicService,
    private _productService: ProductService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _orderedService: OrderedService,
    private _memberService: MemberService,
    private _subcategoryService: SubcategoryService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.load_all_subcategories();
  }


  ngOnInit () {

    this._adapter.setLocale('pt');

    this.entityForm = this.createForm()
    this.setFormValues(this.data.ordered, this.entityForm)

    this.initializeAutoCompletes()

    // check is is insert or update
    if (this.data.ordered.id && this.data.ordered.id != "0") {

      console.log("edit  >>>>>> " + this.data.product.name)

      this.isEdit = true;
      this.local_title = "Inscrição: " + this.data.product.name

      this.origins.push({name: "GN1", value: "GN1"})
      this.origins.push({name: "Admin", value: "Admin"})
      this.origins.push({name: "iOS", value: "iOS"})
      this.origins.push({name: "Android", value: "Android"})
      this.origins.push({name: "Web", value: "web"})

    } else {

      console.log("insert --------------------")

      this._productService.loadProductItensByProduct(this.data.product.id)
        .subscribe((eventsProd) => {
          eventsProd.forEach((evtProd) => {
            this._eventService.selectById(evtProd.payload.doc.data().event_id)
              .subscribe((evt) => {

                /*
                console.log("product name: " + this.data.product.name)
                console.log("event_id: " + evtProd.payload.doc.data().event_id)
                console.log("evt.id: " + evt.id)
                console.log("event name: " + evt.name)
                */

                console.log("control by topic: " + evt.control_ticket_by_topic)

                this.controlByTopic = evt.control_ticket_by_topic

                if (evt.control_ticket_by_topic) {
                  let arrayTopics: any[] = []

                  this._topicService.selectByEventId(evtProd.payload.doc.data().event_id)
                    .subscribe((topics) => {
                      topics.forEach((topic) => {
                        //  console.log("topic name " + topic.payload.doc.data().name )
                        //  console.log("topic id " + topic.payload.doc.id )
                        arrayTopics.push({
                          "id": topic.payload.doc.id,
                          'name': topic.payload.doc.data().name,
                          'date': topic.payload.doc.data().date,
                          'text1': topic.payload.doc.data().text1 || '',
                          'text2': topic.payload.doc.data().text2 || '',
                          'text3': topic.payload.doc.data().text3 || '',
                        })
                      })

                      this.topicDataSource = new MatTableDataSource(arrayTopics)
                    })

                }

              })
          })
        })

      //    this._eventPreviewService.getFullEvent({id: this.data.product.id})
      //        .then((ret) => {

      this.isEdit = false
      this.local_title = "Inscrição: " + this.data.product.name

      this.origins.push({name: "GN1", value: "GN1"})
      this.origins.push({name: "Admin", value: "Admin"})

      //        })

    }


  }

  applyFilter (filterValue: string) {
    //   this.dataSource.filter = filterValue.trim().toLowerCase();

  }

  createEntity (data: any, topic: any): Ordered {

    let entity = new Ordered();
    entity.id = data.id || '';

    entity.date = data.date;

    entity.product_id = this.data.product.id
    entity.product_name = this.data.product.name
    entity.member_id = data.member_id;
    entity.member_name = data.member_name;
    entity.member_debit = data.member_debit;
    entity.member_email = data.member_email;
    entity.member_cpf = data.member_cpf;
    entity.member_cellPhone = data.member_cellPhone;

    entity.category_id = data.category_id;
    entity.category_name = data.category_name;

    entity.payment_type = data.payment_type;
    entity.card_brand = data.card_brand;
    entity.card_installments = 1; //data.card_installments;
    entity.Tid = data.Tid;
    entity.total = data.total;
    entity.value = data.value;
    entity.tax = data.tax;
    entity.total_minus_tax = data.total_minus_tax;
    entity.origin = data.origin;

    entity.discount = Number(data.discount);
    entity.returnCode = "00" //data.returnCode;

    entity.cash_operator = this._authService.getIdLogged()

    if (topic) {
      entity.topic_id = topic.id
      entity.topic_name = topic.name
      entity.topic_text1 = topic.text1 || ''
      entity.topic_text2 = topic.text2 || ''
      entity.topic_text3 = topic.text3 || ''
    }

    return entity;

  }

  setFormValues (data, form) {

    if (data.date) {
      let dt = new Date(data.date.seconds * 1000)
      form.controls.date.setValue(dt);
    }

    form.controls.product_id.setValue(data.product_id);
    form.controls.product_name.setValue(data.product_name);

    form.controls.member_id.setValue(data.member_id);
    form.controls.member_name.setValue(data.member_name);
    form.controls.member_debit.setValue(data.member_debit);
    form.controls.member_email.setValue(data.member_email);
    form.controls.member_cpf.setValue(data.member_cpf);
    form.controls.member_cellPhone.setValue(data.member_cellPhone);

    form.controls.category_id.setValue(data.category_id);
    form.controls.category_name.setValue(data.category_name);

    form.controls.card_brand.setValue(data.card_brand);
    form.controls.card_installments.setValue(data.card_installments);
    form.controls.Tid.setValue(data.Tid);

    form.controls.origin.setValue(data.origin);
    form.controls.returnCode.setValue(data.returnCode);

    if (this.isEdit) {
      form.controls.total.setValue(data.total);
      form.controls.value.setValue(data.value);
      form.controls.tax.setValue(data.tax);
      form.controls.total_minus_tax.setValue(data.total_minus_tax);
      form.controls.discount.setValue(data.discount);
    }

    this.load_payment_type(data.origin, data.payment_type);
    form.controls.payment_type.setValue(data.payment_type);

  }

  createForm () {
    let form: FormGroup = this.fb.group({
      date: new FormControl('', [ Validators.required ]),
      member_id: new FormControl('', [ Validators.required ]),
      member_name: new FormControl('', [ Validators.required ]),

      product_id: new FormControl(''),
      product_name: new FormControl(''),

      member_debit: new FormControl(''),
      member_email: new FormControl(''),
      member_cpf: new FormControl(''),
      member_cellPhone: new FormControl(''),

      category_name: new FormControl('', [ Validators.required ]),
      category_id: new FormControl('', [ Validators.required ]),

      payment_type: new FormControl('', [ Validators.required ]),

      card_brand: new FormControl(''),
      card_installments: new FormControl(''),
      Tid: new FormControl(''),

      value: new FormControl('', [ Validators.required ]),
      total: new FormControl('', [ Validators.required ]),
      discount: new FormControl(''),
      tax: new FormControl(''),
      total_minus_tax: new FormControl(''),

      returnCode: new FormControl(''),
      origin: new FormControl('')

    });
    return form
  }

  load_all_subcategories () {
    this._subcategoryService.select()
      .subscribe((result) => {
        result.forEach((item) => {

          this.allSubCategories.push({
            "id": item.payload.doc.id,
            "name": item.payload.doc.data().name,
            "hidden": item.payload.doc.data().hidden,
            "partner": item.payload.doc.data().partner
          })

        })
      })
  }

  selectOrigin (origin) {
    this.origin = origin
    this.load_payment_type(origin, null)
    this.reset_visible()
  }

  load_payment_type (origin, type) {

    this.paymentTypes = [];

    switch (origin) {

      case "GN1":
        this.paymentTypes.push({'name': 'Boleto', 'value': 'Billet'})
        this.paymentTypes.push({'name': 'Cartão', 'value': 'CreditCard'})
        break;

      case "Admin":
        this.paymentTypes.push({'name': 'Free', 'value': 'Free'})
        this.paymentTypes.push({'name': 'Cash', 'value': 'Cash'})
        //    this.paymentTypes.push({ 'name': 'Boleto', 'value': 'Billet' })
        //    this.paymentTypes.push({ 'name': 'Cartão', 'value': 'CreditCard' })
        break;

      case "iOS":
      case "Android":
      case "Web":
        this.paymentTypes.push({'name': 'Cartão', 'value': 'CreditCard'})
        this.paymentTypes.push({'name': 'Boleto', 'value': 'Billet'})
        break;

      case "Desk"://web-prv
        this.paymentTypes.push({'name': 'Cartão', 'value': 'CreditCard'})
        this.paymentTypes.push({'name': 'Boleto', 'value': 'Billet'})
        this.paymentTypes.push({'name': 'Cash', 'value': 'Cash'})
        break;
    }

    if (type)
      this.entityForm.controls.payment_type.setValue(type);

  }


  selectType (type) {

    this.selectedPaymentType = type

    this.entityForm.controls.Tid.setValue("");
    this.entityForm.controls.value.setValue("");
    this.entityForm.controls.total.setValue("");
    this.entityForm.controls.discount.setValue("");
    this.entityForm.controls.total_minus_tax.setValue("");

    switch (type) {
      case "Billet":
        this.currentTax = 0.035
        this.entityForm.controls.tax.setValue(this.currentTax);

        this.tax_visible = true;
        this.value_visible = true;
        this.total_visible = true;
        this.total_mt_visible = true;
        this.tid_visible = true;
        this.discount_visible = false;

        break;
      case "cartao":
      case "CreditCard":
        this.currentTax = 0.037;
        this.entityForm.controls.tax.setValue(this.currentTax);
        this.entityForm.controls.card_brand.setValue("Visa");

        this.tax_visible = true;
        this.value_visible = true;
        this.total_visible = true;
        this.total_mt_visible = true;
        this.tid_visible = true;
        this.discount_visible = false;

        break;
      case "Free":
        this.currentTax = 0;
        this.entityForm.controls.value.setValue(0);
        this.entityForm.controls.total.setValue(0);
        this.entityForm.controls.total_minus_tax.setValue(0);
        this.entityForm.controls.tax.setValue(0);
        this.entityForm.controls.discount.setValue(0);

        this.tax_visible = false;
        this.value_visible = true;
        this.total_visible = true;
        this.total_mt_visible = false;
        this.tid_visible = false;
        this.discount_visible = false;
        break;
      case "Cash":
        this.currentTax = 0;
        this.tax_visible = false;
        this.value_visible = true;
        this.total_visible = true;
        this.total_mt_visible = true;
        this.tid_visible = false;
        this.discount_visible = true;
        break;
    }

    this.value_blur()

  }

  value_blur () {

    let value = Number(this.entityForm.controls.value.value)
    let tax = Number(this.entityForm.controls.tax.value)
    let discount = Number(this.entityForm.controls.discount.value)
    let debit: number = 0;

    if (this.debit_ok) {
      debit = Number(this.entityForm.controls.member_debit.value)
    } else {
      debit = 0
    }

    //  console.log("debit " + debit)

    let total = (value - discount) + debit;
    let tax_value = Number(total * tax)
    let total_minus_tax = Number(total - tax_value)

    if (value > 0)
      this.entityForm.controls.value.setValue(value);

    if (total > 0)
      this.entityForm.controls.total.setValue(total);

    if (total_minus_tax)
      this.entityForm.controls.total_minus_tax.setValue(total_minus_tax);

  }

  include_debit (event) {

    if (event.checked) {
      this.debit_ok = true;
    } else {
      this.debit_ok = false;
    }


    this.value_blur()
  }


  __confirmDialog () {

    let entity: Ordered = this.createEntity(this.entityForm.value, '');

    this.dialog.open(OrderedViewerDialogComponent, {
      width: '780px',
      height: '580px',
      panelClass: 'custom-dialog-container',
      data: {'ordered': entity, 'new_order': false}
    });

  }

  reset_visible () {
    this.tax_visible = false;
    this.value_visible = false;
    this.total_visible = false;
    this.total_mt_visible = false;
    this.tid_visible = false;
    this.discount_visible = false;
  }

  checkOnClick (event: MatCheckboxChange, element: any): void {
    this.topicDataSource.data.forEach((row) => {
      if (row.id == element.id) {
        row.selected = true
      } else {
        row.selected = false
      }
    })
  }

  async checkASlotAvailability () {
    //console.log(this.data.product.id)
    const checkResult = await this._slotService.checkSlotsAvailable(this.data.product.id)
    const check = checkResult[ 0 ][ 0 ]
    const available = check.slot_quantity
    const used = check.slot_used
    const wait = check.slot_wait
    const wait_used = check.slot_wait_used

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '450px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Vagas", message: "<b>Disponíveis</b>" + "<br>Total: " + available + " // Usadas: " + used + "<br><b>Em espera</b>" + "<br>Total: " + wait + " // Usadas: " + wait_used}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this.insertOrder()
      }
    })

  }

  insertOrder () {
    if (this.entityForm.valid) {

      this._orderedService.spinner = true;

      let entity: Ordered;

      if (this.controlByTopic) {
        this.topicDataSource.data.forEach((row) => {
          if (row.selected) {
            entity = this.createEntity(this.entityForm.value, row);
            //console.log("entity whth topic: " + JSON.stringify(entity))
          }
        })
      } else {
        entity = this.createEntity(this.entityForm.value, null);
        // console.log("entity without topic: " + JSON.stringify(entity))
      }

      this._orderedService.insert(entity)
        .then((e) => {
          console.log("success")
          this._slotService.updateSlotQtd(entity.product_id, entity.topic_id, true)
          this.snackBar.openSnackBar("Sucesso!", '', 'success')
        })
        .catch((error) => {
          console.log("error insert ordered")
          this.snackBar.openSnackBar("Erro!", '', 'error')
        })
        .finally(() => {
          this._orderedService.spinner = false;
          this.dialog.closeAll()
        })

    }

  }

  /*
  _insertOrder () {
      if (this.entityForm.valid) {
          let entity: Ordered = this.createEntity(this.entityForm.value, '');
          this._orderedService.spinner = true;
          //  console.log(JSON.stringify(this.ordered))
          this._orderedService.insert(entity)
              .then((e) => {
                  console.log("success")
                  this.snackBar.openSnackBar("Sucesso!", '', 'success')
              })
              .catch((error) => {
                  console.log("error insert ordered")
                  this.snackBar.openSnackBar("Erro!", '', 'error')
              })
              .finally(() => {
                  this._orderedService.spinner = false;
                  this.dialog.closeAll()
              })
      }
  }
  */


  // AUTOCOMPLETES

  initializeAutoCompletes () {

    this.searchMemberControl = new FormControl();
    this.searchMemberControl.valueChanges.subscribe(val => {
      if (val != undefined) this.updateMemberSearchList(val);
    })

  }

  // MEMBERS AUTOCOMPLETE

  cleanMemberSearch () {
    this.members = []
  }

  updateMemberSearchList (val) {

    if (val.length > 3) {

      this._memberService.selectStartAt(val)
        .subscribe((result) => {

          this.members = []

          result.forEach((item) => {
            this.members.push({
              "id": item.id,
              "name": item.data().name,
              "email": item.data().email,
              "cpf": item.data().cpf,
              "balance": item.data().balance,
              "subCategory": item.data().subCategory,
              "cellPhone": item.data().cellPhone
            })

          })

        })

    }
  }

  displayMember (value) {

    if ((value !== null) && (value !== undefined) && (value !== "")) {

      this.entityForm.controls.member_id.setValue(value.id);
      this.entityForm.controls.member_name.setValue(value.name);
      this.entityForm.controls.member_email.setValue(value.email);
      this.entityForm.controls.member_cpf.setValue(value.cpf);
      this.entityForm.controls.member_debit.setValue(value.balance);
      this.entityForm.controls.member_cellPhone.setValue(value.cellPhone);
      this.entityForm.controls.category_id.setValue(value.subCategory.id);
      this.entityForm.controls.category_name.setValue(value.subCategory.name);

      return value.name;

    } else {
      return "";
    }

  }

  // FIM AUTOCOMPLETE



}

